import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { Dropdown, Form, Button } from 'react-bootstrap';
import {
  fetchMembers,
  fetchInactiveMembers,
  setUserTypeParam,
} from '../../actions/team';
import { PER_PAGE_LIMIT } from '../../constants';

const TeamMemberType = ({
  icon,
  title = 'ROLE',
  options = [],
  selectedValues = [],
  statusType,
}) => {
  const [tempSelected, setTempSelected] = useState(selectedValues);
  const [appliedSelected, setAppliedSelected] = useState(selectedValues);
  const dispatch = useDispatch();
  const teamData = useSelector((state) => state.team);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTempSelected(selectedValues || []);
    setAppliedSelected(selectedValues || []);
  }, []);

  // toggle using ID
  const toggleSelection = (id) => {
    setTempSelected((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const handleToggle = (isOpen) => {
    setShow(isOpen);

    if (isOpen) {
      // Reset temp from applied when opening
      setTempSelected(appliedSelected);
    }
  };
  const handleApply = () => {
    setAppliedSelected(tempSelected);

    // return selected objects OR IDs
    const selectedItems = options.filter((opt) =>
      tempSelected.includes(opt.id)
    );
    dispatch(setUserTypeParam(selectedItems.map((item) => item.id)));

    const uT = selectedItems.map((item) => item.id);
    const userTypeAdd = {
      memberStatus: statusType,
      keyword: teamData.searchParam,
    };
    if (uT.length > 0) {
      userTypeAdd.userTypes = uT;
    }

    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      page: 1,
      limit: PER_PAGE_LIMIT,
      summaryList: false,
      filter: JSON.stringify(userTypeAdd),
    };

    if (statusType === 'active') {
      dispatch(fetchMembers(params));
    }
    if (statusType === 'inactive') {
      dispatch(fetchInactiveMembers(params));
    }
    setShow(false);
  };

  const handleClear = () => {
    setTempSelected([]);
  };

  // fix for object
  const filteredOptions = options;

  return (
    <Dropdown autoClose="outside" show={show} onToggle={handleToggle}>
      <Dropdown.Toggle variant="outline-primary">
        {icon} {`${title} `}
      </Dropdown.Toggle>

      <Dropdown.Menu align="end" style={{ padding: '5px 10px 5px 10px' }}>
        <div className="text-muted small fw-bold">Role</div>

        <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
          {filteredOptions.map((opt) => (
            <Form.Check
              key={opt.id}
              id={`checkbox-${opt.id}`}
              type="checkbox"
              label={opt.label.charAt(0).toUpperCase() + opt.label.slice(1)}
              checked={tempSelected.includes(String(opt.id))}
              onChange={() => toggleSelection(String(opt.id))}
              className="mb-1"
            />
          ))}
        </div>

        <hr className="my-2" />

        <div className="d-flex justify-content-between align-items-center">
          <Button
            variant="link"
            className="p-0 text-decoration-none"
            onClick={handleClear}
          >
            Clear
          </Button>

          <Button variant="primary" size="sm" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

TeamMemberType.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  options: PropTypes.array,
  selectedValues: PropTypes.array,
  statusType: PropTypes.string,
};

export default TeamMemberType;
